import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CreateProfileComponentService {
    private addressFormValidSubject = new BehaviorSubject<boolean>(false);

    setFormValidity(valid: boolean): void {
        this.addressFormValidSubject.next(valid);
    }

    getFormValidity(): Observable<boolean> {
        return this.addressFormValidSubject.asObservable();
    }
}
